/**
 * GLORIANA (17.10.2026): the true gift timer of the cart drawer (snippets/gl-cart-timer.liquid), port of Bella Mia
 * assets/bm-cart-timer.js. The drawer is re-rendered by innerHTML on every change, so every render is a new element;
 * the count lives in localStorage gl_gift_timer {t: cart token, end: ms}.
 * 00:00 -> localStorage gl_gifts_released {t: token} FIRST, then window.__glGifts.reconcile() removes the gifts
 * (snippets/gl-gift-guard.liquid targets 0 gifts while the flag is set). Restore -> the flag goes, reconcile adds
 * the gifts back, a new 10:00 starts on the next render.
 */
(() => {
  if (customElements.get('gl-cart-timer')) return;
  const STATE = 'gl_gift_timer';
  const FLAG = 'gl_gifts_released';
  const seconds = () => { const t = Number(window.__glCartTimerTestSeconds); return t > 0 ? t : 600; };
  const get = (k) => { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } };
  const set = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage blocked */ } };
  const del = (k) => { try { localStorage.removeItem(k); } catch (e) { /* nothing */ } };

  class GlCartTimer extends HTMLElement {
    connectedCallback() {
      this.token = this.dataset.token || '';
      this.pack = Number(this.dataset.pack) > 0;
      this.gifts = Number(this.dataset.gifts) > 0;
      this.addEventListener('click', (e) => {
        const b = e.target instanceof Element ? e.target.closest('[data-gl-ctimer-restore]') : null;
        if (b) { e.preventDefault(); this.restore(b); }
      });
      this.sync();
    }
    disconnectedCallback() { clearTimeout(this.t); }
    part(s) { return this.querySelector(s); }
    render(mode, left) {
      const root = this.part('[data-gl-ctimer]'), count = this.part('[data-gl-ctimer-count]'), rel = this.part('[data-gl-ctimer-rel]'), mmss = this.part('[data-gl-ctimer-mmss]');
      if (!root || !count || !rel) return;
      root.hidden = mode === 'none';
      root.classList.toggle('is-released', mode === 'released');
      count.hidden = mode !== 'count';
      rel.hidden = mode !== 'released';
      if (mode === 'count' && mmss && typeof left === 'number') {
        const s = Math.max(0, left);
        mmss.textContent = `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
      }
    }
    sync() {
      const flag = get(FLAG);
      if (!this.pack) { this.render('none'); return; }
      if (flag && flag.t === this.token && !this.gifts) { this.render('released'); return; }
      if (!this.gifts) { this.render('none'); return; }
      if (flag && flag.t === this.token) del(FLAG);
      let st = get(STATE);
      if (!st || st.t !== this.token || !(Number(st.end) > 0)) { st = { t: this.token, end: Date.now() + seconds() * 1000 }; set(STATE, st); }
      this.end = Number(st.end);
      this.tick();
    }
    tick() {
      clearTimeout(this.t);
      const ms = this.end - Date.now();
      const left = Math.ceil(ms / 1000);
      if (left <= 0) { this.render('count', 0); this.expire(); return; }
      this.render('count', left);
      this.t = setTimeout(() => this.tick(), Math.max(50, Math.min(1000, ms - (left - 1) * 1000)));
    }
    expire() {
      set(FLAG, { t: this.token, at: Date.now() });
      del(STATE);
      this.render('released');
      const live = this.part('[data-gl-ctimer-live]');
      if (live) live.textContent = 'המתנות שוחררו מהעגלה';
      if (window.__glGifts) window.__glGifts.reconcile();
    }
    restore(btn) {
      btn.disabled = true;
      del(FLAG);
      set(STATE, { t: this.token, end: Date.now() + seconds() * 1000 });
      this.end = Date.now() + seconds() * 1000;
      this.render('count', seconds());
      const live = this.part('[data-gl-ctimer-live]');
      if (live) live.textContent = 'המתנות חזרו לעגלה';
      if (window.__glGifts) window.__glGifts.reconcile();
    }
  }
  customElements.define('gl-cart-timer', GlCartTimer);
})();
